import {Container, Col, Row }from 'react-bootstrap';

function FormContact(){
    return (
        <> 
            <Container>
                <Row></Row>
                <Row><h1 className="font-body color-font-primary font-size-xl text-start">Contact Form</h1></Row>
                
                <form>
                    <Row className="mb-2">
                        <label className="font-body color-font-secondary font-size-large text-start">Company Name:</label>
                        <input type="text" className="py-2"  id="form_company_name"  aria-describedby="emailHelp" placeholder="Enter Organization or Company name"/>
                    </Row>
                    <Row className="mb-2">
                        <label className="font-body color-font-secondary font-size-large text-start">Full name:</label>
                        <input type="text" className="py-2" id="form_name"  aria-describedby="emailHelp" placeholder="Entrer your full name" />
                    </Row>
                    <Row className="mb-2">
                        <Col className="px-0 pe-1 text-start">
                            <label className="font-body color-font-secondary font-size-large text-start">Email:</label>
                            <input type="text" className="py-2 w-100"  id="form_email"  aria-describedby="emailHelp" placeholder="Enter the email you'd like to be contacted on."/>
                        </Col>
                        <Col className="px-0 ps-1 text-start">
                            <label className="font-body color-font-secondary font-size-large text-start">Phone Number:</label>
                            <input type="text" className="py-2 w-100"  id="form_number"  aria-describedby="emailHelp" placeholder="Enter the number you'd like to be contacted on."/>
                        </Col>
                        
                    </Row>
                    
                    <Row className="mb-2">
                        <label className="font-body color-font-secondary font-size-large text-start">Idea or Project:</label>
                        <textarea id="form_content" className="py-2 no-resize" aria-describedby="emailHelp"  placeholder="Describe the idea or project you are working on."/>
                    </Row>
                    <Row>
                        <input  className="py-2 rounded" type="submit" value="submit" disabled />
                    </Row>
                    
                    
                </form>
            </Container>
        </>
    )
}

export default FormContact;